export default __webpack_public_path__ + "static/partnersProgramm-30297fc79a1cdb583498bff2e9e65f0f.png";